import {Chip, Stack} from "@mui/material";
import {CAMPAIGN_STATUSES, statusColors, statusLabels} from "../constants";

// Status counts; pass `onSelect` to use the chips as a status filter
export const CampaignStatusChips = ({statusCounts, selected, onSelect, statuses = CAMPAIGN_STATUSES, neutral = false}) => {
  return (
    <Stack direction="row" gap={0.5} flexWrap="wrap">
      {statuses.map(status => (
        <Chip
          key={status} size="small"
          variant={neutral || selected === status ? "filled" : "outlined"}
          color={neutral ? "default" : statusColors[status]}
          sx={neutral ? {
            color: selected === status ? "grey.900" : "text.secondary",
            bgcolor: selected === status ? "grey.300" : "action.hover",
            border: "none",
            fontWeight: selected === status ? 600 : 400,
            "&:hover": {bgcolor: selected === status ? "grey.400" : "grey.200"},
            "&.Mui-focusVisible": {outline: "2px solid", outlineColor: "text.secondary", outlineOffset: 2},
          } : undefined}
          aria-pressed={onSelect ? selected === status : undefined}
          label={`${statusLabels[status]}: ${statusCounts?.[status] ?? 0}`}
          onClick={onSelect ? () => onSelect(selected === status ? null : status) : undefined}
        />
      ))}
    </Stack>
  )
}
